import { useMapEvents } from "react-leaflet";

const AddMarkerOnClick = ({ handleAddMarker }) => {
  const map = useMapEvents({
    click: (e) => {
      // Verificar si el clic fue en un control del mapa
      const target = e.originalEvent.target;
      const isControl = target.closest('.map-controls') || 
                       target.closest('.control-btn') || 
                       target.closest('.address-search-container') ||
                       target.closest('.suggestions-container');
      
      // Solo agregar marcador si NO fue en un control
      if (!isControl) {
        const { lat, lng } = e.latlng;
        handleAddMarker(lat, lng);
      }
    },
  });
  return null;
};

export default AddMarkerOnClick;